import { documentsConstants } from "../constants";
import { documentsRequests } from "../../services";
import { handleErrorMessage } from "../../utils";

export const documentsActions = {};

documentsActions.DownloadDocument = (data, isReset = false) => {
  return (dispatch) => {
    if (isReset) {
      dispatch(reset())
    } else {
      dispatch(request());
      documentsRequests.DownloadDocument(data).then(
        (document) => dispatch(success(document)),
        (error) => dispatch(failure(handleErrorMessage(error)))
      );
    }
  };

  function request() {
    return { type: documentsConstants.DOCUMENTS_REQUEST };
  }

  function success(document) {
    return { type: documentsConstants.DOCUMENTS_SUCCESS, document };
  }

  function failure(error) {
    return { type: documentsConstants.DOCUMENTS_FAILURE, error };
  }

  function reset() {
    console.log('DOWLOADRESET')
    return { type: documentsConstants.DOCUMENTS_RESET }
  }
};

documentsActions.documentUploadEvidence = (data) => {
  return (dispatch) => {
    dispatch(request());
    documentsRequests.DocumentUploadEvidence(data).then(
      (documentUploadEvidence) => dispatch(success(documentUploadEvidence)),
      (error) => dispatch(failure(handleErrorMessage(error)))
    );
  };

  function request() {
    return { type: documentsConstants.DOCUMENTS_EVIDENCE_REQUEST };
  }

  function success(documentUploadEvidence) {
    return {
      type: documentsConstants.DOCUMENTS_EVIDENCE_SUCCESS,
      documentUploadEvidence,
    };
  }

  function failure(error) {
    return { type: documentsConstants.DOCUMENTS_EVIDENCE_FAILURE, error };
  }
};

documentsActions.CargaSeccion = (sectionData, isReset = false) => {
  return (dispatch) => {
    if (isReset) {
      dispatch(reset())
    } else {
      dispatch(request());
      documentsRequests.CargarSeccion(sectionData).then(
        (uploadSecData) => dispatch(success(uploadSecData)),
        (error) => dispatch(failure(handleErrorMessage(error)))
      );
    }
  };

  function request() {
    return { type: documentsConstants.UPLOAD_SECTION_REQUEST };
  }

  function success(uploadSecData) {
    return { type: documentsConstants.UPLOAD_SECTION_SUCCESS, uploadSecData };
  }

  function failure(error) {
    return { type: documentsConstants.UPLOAD_SECTION_FAILURE, error };
  }

  function reset() {
    console.log('AutographSign RESET')
    return { type: documentsConstants.UPLOAD_SECTION_RESET }
  }
};

documentsActions.CargaDocumento = (uploadData) => {
  return (dispatch) => {
    dispatch(request());
    documentsRequests.CargarDocumento(uploadData).then(
      (uploadDocsData) => dispatch(success(uploadDocsData)),
      (error) => dispatch(failure(handleErrorMessage(error.message)))
    );
  };

  function request() {
    return { type: documentsConstants.UPLOAD_DOCUMENTS_REQUEST };
  }

  function success(uploadDocsData) {
    return {
      type: documentsConstants.UPLOAD_DOCUMENTS_SUCCESS,
      uploadDocsData,
    };
  }

  function failure(error) {
    return { type: documentsConstants.UPLOAD_DOCUMENTS_FAILURE, error };
  }
};

documentsActions.GetOcrData = (data) => {
  return (dispatch) => {
    dispatch(request());
    documentsRequests.GetOcrData(data).then(
      (ocrData) => dispatch(success(ocrData)),
      (error) => dispatch(failure(handleErrorMessage(error)))
    );
  };

  function request() {
    return { type: documentsConstants.GET_OCRDATA_REQUEST };
  }

  function success(ocrData) {
    return {
      type: documentsConstants.GET_OCRDATA_SUCCESS,
      ocrData,
    };
  }

  function failure(error) {
    return { type: documentsConstants.GET_OCRDATA_FAILURE, error };
  }
};

documentsActions.RegisterMetadata = (data) => {
  return (dispatch) => {
    dispatch(request());
    documentsRequests.RegisterMetadata(data).then(
      (metaData) => dispatch(success(metaData)),
      (error) => dispatch(failure(handleErrorMessage(error)))
    );
  };

  function request() {
    return { type: documentsConstants.REGISTER_DATA_REQUEST };
  }

  function success(metaData) {
    return {
      type: documentsConstants.REGISTER_DATA_SUCCESS,
      metaData,
    };
  }

  function failure(error) {
    return { type: documentsConstants.REGISTER_DATA_FAILURE, error };
  }
};

documentsActions.GetDocument = (data) => {
  return (dispatch) => {
    dispatch(request());
    documentsRequests.GetDocument(data).then(
      (getDoc) => dispatch(success(getDoc)),
      (error) => dispatch(failure(handleErrorMessage(error)))
    );
  };

  function request() {
    return { type: documentsConstants.GET_DOCUMENTS_REQUEST };
  }

  function success(getDoc) {
    return { type: documentsConstants.GET_DOCUMENTS_SUCCESS, getDoc };
  }

  function failure(error) {
    return { type: documentsConstants.GET_DOCUMENTS_FAILURE, error };
  }
};

documentsActions.AutographSign = (data, isReset = false) => {
  // console.log('ENVIO DE FIRMA', data)
  return (dispatch) => {
    if (isReset) {
      dispatch(reset())
    } else {
      dispatch(request());
      documentsRequests.AutographSignDocument(data).then(
        (response) => dispatch(success(response)),
        (error) => dispatch(failure(handleErrorMessage(error)))
      );
    }
  };

  function request() {
    return { type: documentsConstants.AUTOGRAPH_SIGN_REQUEST };
  }

  function success(response) {
    return { type: documentsConstants.AUTOGRAPH_SIGN_SUCCESS, response };
  }

  function failure(error) {
    return { type: documentsConstants.AUTOGRAPH_SIGN_FAILURE, error };
  }

  function reset() {
    console.log('AutographSign RESET')
    return { type: documentsConstants.AUTOGRAPH_SIGN_RESET }
  }
};

documentsActions.GetFacialComparison = (data, isReset = false) => {
  return (dispatch) => {
    if(isReset){
      dispatch(reset())
    }else{
      dispatch(request());
      documentsRequests.GetFacialComparison(data).then(
        (facialResult) => dispatch(success(facialResult)),
        (error) => dispatch(failure(handleErrorMessage(error)))
      );
    }
  };

  function request() {
    return { type: documentsConstants.FACIAL_COMPARISON_REQUEST };
  }

  function success(facialResult) {
    return { type: documentsConstants.FACIAL_COMPARISON_SUCCESS, facialResult };
  }

  function failure(error) {
    return { type: documentsConstants.FACIAL_COMPARISON_FAILURE, error };
  }

   function reset() {
    return { type: documentsConstants.FACIAL_COMPARISON_RESET };
  }
};

documentsActions.RegisterDataTwo = (data) => {
  return (dispatch) => {
    dispatch(request());
    documentsRequests.RegisterDataTwo(data).then(
      (registeredData) => dispatch(success(registeredData)),
      (error) => dispatch(failure(handleErrorMessage(error)))
    );
  };

  function request() {
    return { type: documentsConstants.REGISTERTWO_DATA_REQUEST };
  }

  function success(registeredData) {
    return { type: documentsConstants.REGISTERTWO_DATA_SUCCESS, registeredData };
  }

  function failure(error) {
    return { type: documentsConstants.REGISTERTWO_DATA_FAILURE, error };
  }
};

documentsActions.ValidateIdentityData = (data) => {
  return (dispatch) => {
    dispatch(request());
    documentsRequests.ValidateIdentityData(data).then(
      (valIndetityData) => dispatch(success(valIndetityData)),
      (error) => dispatch(failure(handleErrorMessage(error)))
    );
  };

  function request() {
    return { type: documentsConstants.VALIDATEDENTITY_DATA_REQUEST };
  }

  function success(valIndetityData) {
    return { type: documentsConstants.VALIDATEDENTITY_DATA_SUCCESS, valIndetityData };
  }

  function failure(error) {
    return { type: documentsConstants.VALIDATEDENTITY_DATA_FAILURE, error };
  }
};

documentsActions.GetValidateIdentityData = (data) => {
  return (dispatch) => {
    dispatch(request());
    documentsRequests.GetValidateIdentityData(data).then(
      (getValIndetityData) => dispatch(success(getValIndetityData)),
      (error) => dispatch(failure(handleErrorMessage(error)))
    );
  };

  function request() {
    return { type: documentsConstants.GETVALIDATEDENTITY_DATA_REQUEST };
  }

  function success(getValIndetityData) {
    return { type: documentsConstants.GETVALIDATEDENTITY_DATA_SUCCESS, getValIndetityData };
  }

  function failure(error) {
    return { type: documentsConstants.GETVALIDATEDENTITY_DATA_FAILURE, error };
  }
};

documentsActions.UploadDocumentSectionContent = (data) => {
  return (dispatch) => {
    dispatch(request());
    documentsRequests.UploadDocumentSectionContent(data).then(
      (updateSectionData) => dispatch(success(updateSectionData)),
      (error) => dispatch(failure(handleErrorMessage(error)))
    );
  };

  function request() {
    return { type: documentsConstants.UPLOAD_DOCUMENT_SECTION_CONTENT_REQUEST };
  }

  function success(updateSectionData) {
    return { type: documentsConstants.UPLOAD_DOCUMENT_SECTION_CONTENT_SUCCESS, updateSectionData };
  }

  function failure(error) {
    return { type: documentsConstants.UPLOAD_DOCUMENT_SECTION_CONTENT_FAILURE, error };
  }
}

documentsActions.UploadVideoEvidenceContentJsonResult = (data) => {
  return (dispatch) => {
    dispatch(request());
    documentsRequests.UploadVideoEvidenceContentJsonResult(data).then(
      (uploadVideoJson) => dispatch(success(uploadVideoJson)),
      (error) => dispatch(failure(error.message))
    );
  };

  function request() {
    return { type: documentsConstants.UPLOAD_VIDEO_EVIDENCE_JSON_REQUEST };
  }

  function success(uploadVideoJson) {
    return { type: documentsConstants.UPLOAD_VIDEO_EVIDENCE_JSON_SUCCESS, uploadVideoJson };
  }

  function failure(error) {
    return { type: documentsConstants.UPLOAD_VIDEO_EVIDENCE_JSON_FAILURE, error };
  }
}

documentsActions.UploadMinutiae = (data) => {
  return (dispatch) => {
    dispatch(request());
    documentsRequests.UploadMinutiae(data).then(
      (uploadMinutiaeData) => dispatch(success(uploadMinutiaeData)),
      (error) => dispatch(failure(handleErrorMessage(error)))
    );
  };

  function request() {
    return { type: documentsConstants.UPLOAD_MINUTIAE_REQUEST };
  }

  function success(uploadMinutiaeData) {
    return { type: documentsConstants.UPLOAD_MINUTIAE_SUCCESS, uploadMinutiaeData };
  }

  function failure(error) {
    return { type: documentsConstants.UPLOAD_SECTION_FAILURE, error };
  }
}

documentsActions.DigitalSignSATDocument = (data) => {
  return (dispatch) => {
    dispatch(request());
    documentsRequests.DigitalSignSATDocument(data).then(
      (digitSATData) => dispatch(success(digitSATData)),
      (error) => dispatch(failure(handleErrorMessage(error)))
    );
  };

  function request() {
    return { type: documentsConstants.DIGITAL_SING_SAT_DOC_REQUEST };
  }

  function success(digitSATData) {
    return { type: documentsConstants.DIGITAL_SING_SAT_DOC_SUCCESS, digitSATData };
  }

  function failure(error) {
    return { type: documentsConstants.DIGITAL_SING_SAT_DOC_FAILURE, error };
  }
}

documentsActions.CargaDocumentoWithSection = (data) => {
  return (dispatch) => {
    dispatch(request());
    documentsRequests.CargaDocumentoWithSection(data).then(
      (cargaDocData) => dispatch(success(cargaDocData)),
      (error) => dispatch(failure(handleErrorMessage(error)))
    );
  };

  function request() {
    return { type: documentsConstants.CARGADOC_WITH_SECTION_REQUEST };
  }

  function success(cargaDocData) {
    return { type: documentsConstants.CARGADOC_WITH_SECTION_SUCCESS, cargaDocData };
  }

  function failure(error) {
    return { type: documentsConstants.CARGADOC_WITH_SECTION_FAILURE, error };
  }
}